import { Component, Input } from '@angular/core';
import { Learnset } from 'src/app/models/learnset.model';

@Component({
  selector: 'app-create-result-step',
  templateUrl: './create-result-step.component.html',
  styleUrls: ['./create-result-step.component.scss'],
  standalone: false
})
export class CreateResultStepComponent {

  @Input() learnset?: Learnset | null;
  @Input() isDemo?: boolean;

  constructor() {}

  ngOnInit() {}
}
